import { MultipleChoiceExamEndIllustration } from '../../../../../assets/illustrations';
import { setCodingExamStep } from '../../../../../store/exam/slice';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

function ExamEnd() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const navigation = () => {
        dispatch(setCodingExamStep('KYC'));
        navigate('/workspace');
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <MultipleChoiceExamEndIllustration />
            <span className={styles.title}>Well done!</span>
            <span className={styles.text}>You finished the exam.</span>
            <Button
                type='Primary'
                onClick={navigation}
                text='Go to dashboard'
                className={styles.navigate}
            />
        </MotionWrapper>
    )
};

export default ExamEnd;
